import { anotherComponentHookCriteria } from '../../helpers';
export function viewerNavigationPlugin(flowApi) {
  return function (router) {
    router.transitionService.onBefore({
      to: anotherComponentHookCriteria
    }, handleNavigation, {
      invokeLimit: 1
    });
    return {
      name: 'WixUIRouterViewerNavigation'
    };
  };
  function handleNavigation(transition) {
    return transition.targetState().withParams({
      scrollToTop: true,
      ...transition.params()
    });
  }
}
//# sourceMappingURL=plugin.js.map